import { Images } from "../../Assets/Index";
import { useDispatch, useSelector } from "react-redux";
import {
  dispatchtoast,
  ExtractDate,
  ExtractTime,
  getLocalStorageItem,
} from "../../Utils";

import { Avatar, DatePicker, Table } from "antd";
import { LiaCitySolid } from "react-icons/lia";
import { PiCity } from "react-icons/pi";
import { IoCaretBack } from "react-icons/io5";
import { FaCalendar } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router-dom";
import { useCommmonStore } from "../../Store/CommonReducer";
import { useEffect, useState } from "react";
import { getfetchResult } from "./ChartEndpoint";
import { AnimatePresence } from "framer-motion";
const ResultData = () => {
  const walletBalance = useSelector((state) => state.colorGame.walletBal);
  const withdrawAmount = useSelector((state) => state.colorGame.withdrawAmt);
  const navigate = useNavigate();
  const { profileDetail } = useCommmonStore();
  const location = useLocation();
  const slugtype = location?.state?.slugType;
  const startDate = location?.state?.startDate;
  const endDate = location?.state?.endDate;
  const [resultData, setResultData] = useState([]);
  //   const [startDate, setStartDate] = useState(false);
  //   const [endDate, setEndDate] = useState(false);
  useEffect(() => {
    console.log(startDate, endDate, slugtype);
    getfetchResult(`${slugtype}&start_date=${startDate}&end_date=${endDate}`)
      .then((res) => {
        if (res.status) {
          setResultData(res.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);
  const columns = [
    {
      title: "Room Id",
      dataIndex: "room_id",
      key: "room_id",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {data}
        </p>
      ),
    },
    {
      title: "Winner Option",
      dataIndex: "winner_option",
      key: "winner_option",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {data}
        </p>
      ),
    },

    {
      title: "Time",
      dataIndex: "createdAt",
      key: "createdAt",
      className: " font-dmsans text-sm",
      render: (data) => (
        <p className="text-xs font-dmsans items-center flex justify-center ">
          {ExtractDate(data)}.{ExtractTime(data)}
        </p>
      ),
    },
  ];
  return (
    <>
      <div className="flex justify-center pb-20 items-center bg-black rounded-lg">
        <div className="w-full ">
          <div className="flex justify-between bg-gradient-to-r from-[#734e0c] via-[#ba7d13] to-[#e9a52f] px-8  py-2 gap-x-3 items-center ">
            <div className="text-white font-semibold flex  items-center gap-4 ">
              <IoCaretBack
                className="bg-[#ba7d13] h-7 w-7 rounded-lg cursor-pointer text-white"
                onClick={() => navigate("/chart")}
              />
              <p className="text-xl font-normal custome">
                {getLocalStorageItem("userDetails")?.name}Result
              </p>
            </div>
            <div className="flex justify-between items-center">
              <img src={Images.Money} className="w-8 m-auto my-2" alt="money" />
              <p className="text-white text-sm  custome">
                ₹ {profileDetail?.user?.wallet_balance ?? 0}
              </p>
            </div>
          </div>
          <div className="h-[100vh] bg-black overflow-scroll">
            {" "}
            <div>
              <div className="m-4 bg-black ">
                {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center rounded-lg mt-6">
                  <div className="ml-4">
                    <p className="text-white custome text-sm">
                      Select Start Date
                    </p>
                    <DatePicker
                      onChange={(val) => setStartDate(val)}
                      suffixIcon={<FaCalendar className="text-gray-400" />}
                      style={{
                        width: 200,
                        background: "#000",
                        border: "1px solid #d9d9d9",
                        fontFamily: "cursive",
                        color: "#fff",
                      }}
                      className="datepicker-placeholder"
                    />
                  </div>
                  <div className="ml-4">
                    <p className="text-white custome text-sm">
                      Select End Date
                    </p>
                    <DatePicker
                      onChange={(val) => setEndDate(val)}
                      suffixIcon={<FaCalendar className="text-gray-400" />}
                      style={{
                        width: 200,
                        background: "#000",
                        border: "1px solid #d9d9d9",
                        fontFamily: "cursive",
                        color: "#fff",
                      }}
                      className="datepicker-placeholder"
                    />
                  </div>
                </div> */}

                <div>
                  {resultData && (
                    <div className="flex justify-center  items-center  bg-black rounded-lg">
                      <AnimatePresence>
                        <Table
                          size="small"
                          rowHoverable={false}
                          columns={columns}
                          // loading={isLoading}
                          dataSource={resultData}
                          className="w-screen sm:w-screen"
                          // scroll={{
                          //   y: 240,
                          // }}
                          pagination={false}
                        />
                      </AnimatePresence>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResultData;
